// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import lightning02Icon from "@/assets/icons/lightning-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Lightning02IconProps = Omit<IconProps, "name">;

export function Lightning02Icon(props: Lightning02IconProps): React.ReactNode {
  return <Icon name={lightning02Icon} {...props} />;
}
